import React from 'react';
import {Link} from "react-router-dom";

const CompanyManagerMenu = () => {
    return (
        <div id="dashboardSidebar" className="nav-collapse collapse ">
            <a className="nav-link dropdown-toggle"
               href="#keyStatistics" role="button"
               data-bs-toggle="collapse"
               aria-expanded="false"
               aria-controls="keyStatistics">Statistiques Clés</a>

            <div id="keyStatistics" className="nav-collapse collapse ">
                <Link className="nav-link" to="/dashboard/company">Notifications importantes</Link>
                <Link className="nav-link" to="/dashboard/company">Messages non lus</Link>
                <Link className="nav-link" to="/dashboard/company">Activités récentes</Link>
            </div>
        </div>
    );
};

export default CompanyManagerMenu;